import { Component } from '@angular/core';
import { ComponentBase } from 'src/app/base-classes/componet-base';
import { PickupAssistant } from '../../models/pickup-assistant';
import { PickupAssistantService } from '../../services/pickup-assistant.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-edit-pickup-wrapper',
  templateUrl: './edit-pickup-wrapper.component.html',
  styleUrls: ['./edit-pickup-wrapper.component.scss']
})
export class EditPickupWrapperComponent extends ComponentBase {

  constructor(private pickupAssistantService: PickupAssistantService, 
    private activatedRoute: ActivatedRoute
  ) { super(); }
  pickup_assistants: PickupAssistant[];  
  public option = 1;
  ngOnInit() {
    let sub1 = this.pickupAssistantService.getPickupAssistantsForStudent().subscribe((assistants) => {
      this.pickup_assistants = assistants;
    });
    let sub2 = this.activatedRoute.queryParams.subscribe(res => {

      if(res['addNew'] == "true"){
        this.option = 2;
      }
      else{
        this.option = 1;
      }
    });    
    this.addSubscription(sub1);
    this.addSubscription(sub2);
  }

}
